import React from 'react'
import CopyButtonBase from './CopyButtonBase'

export default function CopyButtonForText({ children, targetId, textToCopy, ...props }) {
  const value = textToCopy ?? (typeof children === 'string' ? children : '')

  return (
    <span style={{ display: 'inline-flex', alignItems: 'baseline', gap: '0.25rem' }}>
      <span>{children ?? value}</span>
      <CopyButtonBase
        targetId={targetId}
        textToCopy={value}
        variant="subtle"
        {...props}
      />
    </span>
  )
}
